import React from "react";
import { H3, ListItem, Text } from "components/core/Typography";
import { CircleArrow } from "components/core/Icons";

import "./WhySection.scss";

const reasonsSDC = [
	"The most choices offered in location, size, and price",
	"Storage solutions across the U.S.",
	"Worry-free online reservations"
];

const WhySection = () => (
	<div className="why-section hide-below-desktop">
		<H3
			weight="semiBold"
			size="large"
		>
			Why Storage.com?
		</H3>
		<ul>
			{reasonsSDC.map((reason) => (
				<ListItem
					key={reason}
					size="small"
					last
				>
					<CircleArrow />
					<Text size="small">{reason}</Text>
				</ListItem>
			))}
		</ul>
		<div className="masked-img" />
	</div>
);

export default WhySection;
